import { FAILURE, POST, SUCCESS, GET } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import { BASE_URL } from "../utils/const/base-url";

export async function obtenerInfoUsuario(obj) {
    try {
        let data = { error: true };
        const { status, message, body } = await fetch(
            `${BASE_URL}/usuario/obtener-info-usuario`,
            {
                headers: getHeaders(),
                method: GET,
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerInfoUsuario err");
        console.log(err);
        return { error: true, message: err };
    }
}